import { useRef, useState } from 'react';

type OnFunction = () => void;
type OffFunction = () => void;
type ToggleFunction = () => void;

export function useBoolean(initialState: boolean) {
  const [value, setValue] = useState(initialState);

  const updateValue = useRef<{
    toggle: ToggleFunction;
    on: OnFunction;
    off: OffFunction;
  }>({
    toggle: () => setValue((oldValue) => !oldValue),
    on: () => setValue(true),
    off: () => setValue(false),
  });

  return [value, updateValue.current] as [
    typeof value,
    typeof updateValue.current
  ];
}
